import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppRoutes, AUTH_CLIENT_TOKEN, AuthClientProvider } from '@core';
import { map, Observable, take } from 'rxjs';

export const isNotAuthedGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authClient: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  const router: Router = inject(Router);

  return authClient.isAuthed$.pipe(
    take(1),
    map((authed: boolean): boolean | UrlTree => (authed ? router.parseUrl(`/${AppRoutes.ROOT}`) : true))
  );
};
